import { Base } from './base.model';

export class DocusignTemplate extends Base {
  public templateId: string;
  public description: string;
}
